import { IOCourseIframeList } from '../IOCoursesList/components/IOCourseIframeList';

export function CoursesListFrame() {
  return (
    <div className="courses-management">
      <IOCourseIframeList />
    </div>
  );
}
